import type { IStyleFunctionOrObject } from '@fluentui/react';
import { FontWeights } from '@fluentui/react';
import type { INavLinkStyleProps, INavLinkStyles } from '@m365-admin/nav';

export function getNavLinkStyles(
  props: INavLinkStyleProps,
): IStyleFunctionOrObject<INavLinkStyleProps, INavLinkStyles> {
  const { theme, isSelected } = props;
  const { semanticColors } = theme;

  const styles: Partial<INavLinkStyles> = {
    root: {
      color: isSelected ? semanticColors.bodyText : semanticColors.buttonText,
      fontWeight: isSelected ? FontWeights.semibold : FontWeights.regular,
    },
    icon: {
      color: isSelected ? theme.palette.themePrimary : semanticColors.bodyText,
    },
    iconContainer: {
      '::before': [
        {
          borderRadius: theme.effects.roundedCorner4,
        },
      ],
    },
  };

  return styles;
}
